<script>
	import { itemStore } from "./itemStore.js";
	import { writable } from "svelte/store";
	import EditContainer from "./EditContainer.svelte";
	import Icon from "@iconify/svelte";

	let inputValue = "";
	let selectedItem = writable(null); // Store the selected item for editing

	function onSubmit(event) {
		event.preventDefault();
		if (inputValue.trim()) {
			itemStore.addItem(inputValue.trim());
			inputValue = ""; // Clear the input field after submission
		}
	}

	function deleteItem(itemId) {
		itemStore.deleteItem(itemId);
		selectedItem.update((item) => (item?.id === itemId ? null : item));
	}

	function selectItem(item) {
		selectedItem.set(item);
	}

	function handleSave(event) {
		const { editValue, selectedVariable, selectedVariableValue } = event.detail;
		console.log(editValue, selectedVariable, selectedVariableValue);
		// Update itemStore with new values here
		selectedItem.set(null);
	}

	async function copyToClipboard(text) {
		try {
			await navigator.clipboard.writeText(text);
			alert("Copied to clipboard");
		} catch (err) {
			console.error("Failed to copy: ", err);
		}
	}
</script>

<main>
	<div class="container">
		<form on:submit={onSubmit}>
			<div class="input-group">
				<input
					type="text"
					bind:value={inputValue}
					placeholder="Enter command here"
				/>
				<button type="submit">Add</button>
			</div>
		</form>

		<ul class="item-list">
			{#each $itemStore as item, index}
				<li on:click={() => selectItem(item)}>
					<span class="item-text">{item.finalCommand}</span>
					<button
						class="copy-button"
						on:click={(event) => {
							event.stopPropagation();
							copyToClipboard(item.finalCommand);
						}}
					>
						<Icon icon="ph:copy" style="color: black" class="icon" />
					</button>
				</li>
			{/each}
		</ul>
	</div>

	{#if $selectedItem}
		<EditContainer
			{deleteItem}
			itemId={$selectedItem?.id}
			on:save={handleSave}
		/>
	{/if}
</main>

<style>
	.container {
		max-width: 400px;
		margin: 20px auto;
		padding: 20px;
		background-color: #f9f9f9;
		border-radius: 8px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}

	.input-group {
		display: flex;
		margin-bottom: 20px;
	}

	input {
		flex-grow: 1;
		padding: 10px;
		font-size: 16px;
		border: 1px solid #ccc;
		border-radius: 4px 0 0 4px;
	}

	button {
		padding: 10px 20px;
		font-size: 16px;
		background-color: #4caf50;
		color: white;
		border: 1px solid #4caf50;
		border-radius: 0 4px 4px 0;
		cursor: pointer;
	}

	button:hover {
		background-color: #45a049;
	}

	.item-list {
		list-style-type: none;
		padding: 0;
	}

	.item-list li {
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: white;
		margin-bottom: 8px;
		padding: 10px;
		border-radius: 4px;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
		cursor: pointer;
		width: 100%;
		box-sizing: border-box;
	}

	.item-list li span.item-text {
		flex-grow: 1;
		word-break: break-word;
		overflow-wrap: break-word;
		margin-right: 10px;
	}

	.copy-button {
		color: black;
		background: none;
		border: none;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>
